import type { ReactNode } from 'react';

import LogoSvg from '~/assets/logos/logo-32x--insomnia-core.svg';

export const TrailLinesBox = ({ children, width = 380 }: { children: ReactNode; width?: number }) => {
  return (
    <div
      className="relative z-10 flex min-h-[300px] w-full flex-shrink-0 rounded bg-white"
      style={{ width: `${width}px` }}
    >
      <div className="absolute top-[-32px] flex w-full flex-col items-center justify-center">
        <img className="w-16" src={LogoSvg} alt="logo" />
      </div>
      <div className="flex w-full flex-col gap-[16px] p-6">{children}</div>
    </div>
  );
};
